<template>
    <vx-card no-shadow class="mb-8">
        <div class="vx-row">
            <!-- Шапка формы -->
            <div class="vx-col w-full">
                <div class="flex items-center">
                    <vs-avatar
                        class="avatarImg"
                        v-if="avatar"
                        :size="windowWidth < 992 ? '40px' : '120px'"
                        :src="avatar"
                        @click="handleFileEdit"
                    />
                    <vs-avatar
                        class="lg:text-5xl"
                        v-else
                        :size="windowWidth < 992 ? '40px' : '120px'"
                        :text="avatarText"
                    />

                    <div class="ml-2 lg:ml-5">
                        <h3 class="text-base lg:text-4xl mb-4">
                            {{ userName }}
                        </h3>
                        <div class="flex items-center">
                            <div>
                                <label
                                    for="avatar_input"
                                    class="vs-component vs-button vs-button-primary vs-button-filled small files_input_button"
                                >
                                    {{ avatarBtnText }}
                                </label>
                                <input
                                    v-if="file"
                                    accept=".jpg, .jpeg, .png, .gif"
                                    type="file"
                                    id="avatar_input"
                                    class="avatar_input hidden"
                                    ref="avatarUpload"
                                    v-on:change="handleFileUpload()"
                                />
                            </div>
                            <vs-popup
                                ref="avatarCropper"
                                id="avatarCropper"
                                :title="$t('crop_image')"
                                :active.sync="croperModal"
                            >
                                <div class="avatar_cropper" v-if="dataUrl">
                                    <img
                                        ref="avatarImg"
                                        @load.stop="createCropper"
                                        :src="dataUrl"
                                    />
                                    <div
                                        class="avatar_modal_footer flex flex_justify_between_items_center"
                                    >
                                        <vs-button
                                            @click="uploadImage"
                                            class="avatar_select files_input_button"
                                        >
                                            {{ $t("save") }}
                                        </vs-button>

                                        <vs-button
                                            @click="cropper.rotate(-45)"
                                            color="warning"
                                            class="ml-4"
                                            icon="rotate_left"
                                        ></vs-button>
                                        <vs-button
                                            @click="cropper.rotate(45)"
                                            class="ml-2"
                                            color="warning"
                                            icon="rotate_right"
                                        ></vs-button>
                                    </div>
                                </div>
                            </vs-popup>
                            <!--<vs-button @click="avatarDelete()" v-if="avatar" class="ml-2 py-2" size="small" color="danger" type="border">Удалить аватар</vs-button>-->
                        </div>
                    </div>
                </div>
            </div>

            <!-- Настройки -->
            <div class="vx-col md:w-1/2 w-full">
                <!-- user address -->
                <!-- <vs-input
                    class="w-full mt-4"
                    :label="$t('address')"
                    v-model="contactForm.address"
                    v-validate="'required'"
                    name="address"
                />
                <span
                    class="text-danger text-sm"
                    v-show="errors.has('address')"
                    >{{ $t("validation_required") }}</span
                > -->

                <vs-input
                    class="w-full mt-4"
                    v-validate="'required|numeric|max:13|min:11'"

                    :label="$t('phone_number_with_country_phone_code')"
                    v-model="contactForm.phone"
                    name="phone"
                />
                <span class="text-danger text-sm" v-show="errors.has('phone')">
                   {{ getErrorMessage(errors.first('phone')) }}
                </span >

                <vs-input
                    class="w-full mt-4"
                    label="E-mail"
                    v-model="contactForm.email"
                    v-validate="'required'"
                    name="email"
                />
                <span
                    class="text-danger text-sm"
                    v-show="errors.has('email')"
                    >{{ $t("validation_required") }}</span
                >
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-input
                    class="w-full mt-4"
                    label="Skype"
                    v-model="contactForm.skype"
                    name="skype"
                />
                <span
                    class="text-danger text-sm"
                    v-show="errors.has('skype')"
                    >{{ $t("validation_required") }}</span
                >

                <vs-input
                    class="w-full mt-4"
                    :label="$t('extra_data')"
                    v-model="contactForm.extra_data"
                    name="extra_data"
                />
                <span
                    class="text-danger text-sm"
                    v-show="errors.has('extra_data')"
                    >{{ $t("validation_required") }}</span
                >

                <vs-checkbox
                    class="mt-4 lg:mt-12"
                    :disabled="check_allow_change_adviser"
                    v-model="contactForm.notify_me_from_email"
                    >{{ $t("notify_by_mail") }}</vs-checkbox
                >
            </div>
            <div class="vx-col md:w-1/2 w-full mt-4">
                <vs-button
                    class="edit_btn contact_btn edt_btn"
                    color="primary"
                    @click="contactFormSubmit()"
                    icon-pack="feather"
                    icon="icon-save"
                    type="filled"
                    >{{ $t("save") }}</vs-button
                >
            </div>
        </div>
    </vx-card>
</template>

<script>
import { mask } from "vue-the-mask";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";

export default {
    directives: { mask },
    props: {
        userData: Object,
        uploadSettings: Object,
    },
    data() {
        return {
            avatar: null,
            contactForm: {
                address: "",
                phone: "",
                email: "",
                skype: "",
                extra_data: "",
                notify_me_from_email: false,
            },
            croperModal: false,

            dataUrl: null,
            cropper: null,
            file: true,

            outputQuality: 0.9,
            cropperOptions: {
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 2,
                movable: true,
                zoomable: true,
                minCropBoxWidth: 150,
                minCropBoxHeight: 150,
            },
            check_allow_change_adviser:null,
        };
    },
    watch: {
        croperModal() {
            this.hiddenHandler();
        },
    },
    created: function () {
        this.avatar = this.userData.avatar;
        for (let key in this.contactForm) {
            if (this.userData[key]) this.contactForm[key] = this.userData[key];
        }
        this.ban_student()
    },

    methods: {
        getErrorMessage(message){
            if (message){
                let words = message.split(' ');
                let translatedMessage = []
                words.forEach((word)=>{
                    let translatedWord = this.$t(word)
                    translatedMessage.push(translatedWord)
                })
                return translatedMessage.join(' ')
            }

        },
        async ban_student(){
            if (this.is_student){
                var obj = (await this.$http.get('/user/ban_student_notification/')).data
                this.check_allow_change_adviser = obj[0].ban_student_notification
            }
        },
        hiddenHandler() {
            this.dataUrl = null;
            this.cropper = null;
            this.file = false;
            setTimeout(() => {
                this.file = true;
            }, 300);
        },
        createCropper() {
            this.cropper = new Cropper(
                this.$refs.avatarImg,
                this.cropperOptions
            );
        },

        async uploadImage() {
            this.$vs.loading({
                container: ".files_input_button",
                scale: 0.45,
            });
            this.cropper.getCroppedCanvas().toBlob(async (avatar) => {
                let formData = new FormData();

                // Заполняем formData перед загрузкой файлов
                formData.append("avatar", avatar, "avatar.png");

                if (formData.has("avatar")) {
                    try {
                        formData.append("uid", this.userData.profileId);

                        // Загружаем файлы на сервер
                        const { data } = await this.$http.post(
                            "/user/avatar/upload/",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );

                        this.$store.commit("user/SET_BY_KEY", {
                            key: "avatar",
                            value: data.avatar,
                        });
                        this.avatar = data.avatar;
                    } catch (error) {
                        this.$vs.notify({
                            text: this.$t("error"),
                            color: "danger",
                        });
                    } finally {
                        this.croperModal = false;
                        this.hiddenHandler();
                        this.$vs.loading.close(
                            ".files_input_button > .con-vs-loading"
                        );
                        this.$vs.notify({
                            text: this.$t("data_saved"),
                            color: "success",
                        });
                    }
                }
            });
        },
        async contactFormSubmit() {
            // Сохраняем настройки контактов пользователя
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.$vs.loading({
                            container: ".edit_btn",
                            scale: 0.6,
                        });

                        await this.$http.put(
                            `user/profile/${ this.userData.profileId }/contact/edit/`,
                            this.contactForm
                        );
                    } catch (e) {
                        this.$vs.notify({
                            text: this.$t("error"),
                            color: "danger",
                        });
                    } finally {
                        this.$vs.loading.close(".edit_btn > .con-vs-loading");
                        this.$vs.notify({
                            text: this.$t("data_saved"),
                            color: "success",
                        });
                    }
                }
            });
        },
        async handleFileEdit() {
            this.$vs.loading();
            this.dataUrl = this.avatar;
            this.croperModal = true;

            setTimeout(() => {
                this.$vs.loading.close();
            }, 1500);
        },
        async handleFileUpload() {
            // Получаем файлы от поля загрузки
            const file = this.$refs.avatarUpload.files[0];
            if (
                this.uploadSettings.max_file_size &&
                file.size / 1024 / 1024 >= this.uploadSettings.max_file_size
            ) {
                this.$vs.notify({
                    text: `Файл ${ files[i].name } превышает ${ this.uploadSettings.max_file_size } мегабайт!`,
                    color: "warning",
                });
            } else {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.dataUrl = e.target.result;
                };

                reader.readAsDataURL(file);

                this.croperModal = true;
            }
        },
    },
    computed: {
        is_student(){
            return this.$store.state.user.user.role.is_student
        },
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        avatarBtnText() {
            // Меняем текст кнопки загрузки аватара
            if (this.avatar) return this.$t("change_avatar");
            else return this.$t("add_avatar");
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if (this.$i18n.locale === "en") {
                // Если имя на англ пустое, используем рус имя
                if (this.userData.first_name_en)
                    return `${ this.userData.last_name_en } ${ this.userData.first_name_en }`;
                else
                    return `${ this.userData.lastName } ${ this.userData.firstName } ${ this.userData.middleName }`;
            } else
                return `${ this.userData.lastName } ${ this.userData.firstName } ${ this.userData.middleName }`;
        },
        avatarText() {
            if (this.userName) {
                // Возвращяем инициалы пользователя
                let title,
                    text = this.userName;

                const textAr = text.split(" ");
                if (textAr.length) {
                    const newTitle = [];
                    textAr.forEach((item) => {
                        newTitle.push(item.substr(0, 1).toUpperCase());
                    });
                    title = newTitle.join("");
                } else title = text.substr(0, 1);
                return title;
            } else return "1";
        },
    },
};
</script>


<style lang="scss">
.avatar_modal_footer {
    margin-top: 15px;
}
.avatar_cropper {
    position: relative;
    img {
        max-width: 100%;
        height: 100%;
        max-height: 400px;
    }
}
@media screen and (max-height: 580px) {
    .avatar_cropper {
        img {
            max-height: 300px;
        }
    }
}

.avatarImg img {
    object-fit: cover;
}
.files_input_button {
    padding: 8.5px 1.5rem !important;
}
.files_input_button,
.edit_btn {
    position: relative;
    .con-vs-loading {
        position: absolute;
    }
}
</style>
